import React, { useState, useEffect } from 'react';
import { Modal, Row, Col, Upload, notification, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { importFileZoneSlotTemplate } from 'store/requests/slot';
import { downloadTemplateFile } from 'store/requests/definitions';

const ImportBulkCapacityUpdate = ({
  onCloseHandler,
  onSuccessCallback,
  slotCapacityLink,
}) => {
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [openImportModal, setOpenImportModal] = useState(false);

  useEffect(() => {
    showInfo();
  }, []);

  const props = {
    name: 'file',
    maxCount: 1,
    headers: {
      authorization: 'authorization-text',
    },
    beforeUpload: (file) => {
      const isExcel =
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || // .xlsx
        file.type === 'application/vnd.ms-excel'; // .xls

      if (!isExcel) {
        notification.error({ message: t('onlyAcceptExcel') });
        return false;
      }

      setFile(file);
      return false;
    },
  };

  const handleSubmit = async () => {
    if (!file) {
      notification.error({ message: t('selectFile') });
      return;
    }

    setIsSubmitting(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('importDataTemplateCode', slotCapacityLink);

    try {
      const res = await importFileZoneSlotTemplate(formData);
      if (res) {
        notification.success({ message: `${t('fileTransferStarted')}${res}` });
        onSuccessCallback();
      }
    } finally {
      setIsSubmitting(false);
      setOpenImportModal(false);
      onCloseHandler();
    }
  };

  const handleDownload = () => {    
    downloadTemplateFile(slotCapacityLink);
  };

  const showInfo = () => {
    Modal.info({
      title: t('slotCapacityImport'),
      content: (
        <div>
          <p>{t('infoForSlotCapacityImport')}</p>
          <p>{t('infoForSlotCapacityImport1')}</p>
        </div>
      ),
      onOk() {
        setOpenImportModal(true);
      },
    });
  };

  return (
    <>
      <Modal
        open={openImportModal}
        maskClosable={false}
        onOk={handleSubmit}
        okButtonProps={{ loading: isSubmitting, disabled: !file }}
        onCancel={onCloseHandler}
        title={t('slotCapacityImport')}
        okText={t('save')}
        cancelText={t('cancel')}
        width={600}
      >
        <Row>
          <Col
            span={12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Card onClick={handleDownload} style={{ cursor: 'pointer' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <DownloadOutlined />
              </div>
              <div>
                <p style={{ margin: '5px', textAlign: 'center' }}>
                  {t('downloadExampleTemplate')}
                </p>
              </div>
            </Card>
          </Col>
          <Col
            span={12}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Upload {...props}>
              <Card style={{ cursor: 'pointer' }}>
                <UploadOutlined />
                <p>{t('uploadReadyTemplate')}</p>
              </Card>
            </Upload>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ImportBulkCapacityUpdate;
